import styled from 'styled-components';

export const SliderContainer = styled.section`
  overflow: hidden;
`;

export const Wrapper = styled.section`
  padding: 0 3rem;
  @media (${({ theme }) => theme.respondTo.desktop}) {
    padding: 0 5rem;
  }
  max-width: var(--max-container-width);
  margin: 0 auto;
  .navigation-wrapper {
    display: flex;
    flex-wrap: wrap;
    position: relative;
  }

  .keen-slider {
    display: flex;
    margin: 0;
    padding: 0;
    overflow: visible;
  }
`;

export const ArrowButton = styled.button`
  background-color: var(--color-secondary);
  width: 7rem;
  height: 7rem;
  position: absolute;
  border: none;
  border-radius: 50%;
  top: calc(50% - 3.5rem);
  cursor: pointer;

  svg {
    fill: black;
    width: 2rem;
    height: 2rem;
    vertical-align: middle;
  }
  &.left {
    @media (${({ theme }) => theme.respondTo.desktop}) {
      transform: translate(-50%);
    }

    left: 0;
    svg {
      transform: rotate(180deg);
    }
  }

  &.right {
    right: 0;
    @media (${({ theme }) => theme.respondTo.desktop}) {
      transform: translate(50%);
    }
  }

  &.disabled {
    display: none;
  }
`;
